<app-portal-collapsible
    icon="adress_book"
    title="Rechnungsadresse"
>
    @if (editMode) {
        <app-billing-address-edit
            [customer]="customer()"
            (close)="toggleEditMode()"
        />
    } @else {
        <app-billing-address-display
            [customer]="customer()"
            (edit)="toggleEditMode()"
        />
    }
</app-portal-collapsible>
